(() => {
  const FADE_DURATION = 700;
  const FADE_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  customElements.whenDefined('slideshow-component').then(() => {
    const SlideshowComponent = customElements.get('slideshow-component');
    const prototype = SlideshowComponent && SlideshowComponent.prototype;

    if (!prototype || prototype.wcCrossfadeInstalled) return;

    const originalTransition = prototype.transitionRichSlideshow;

    const usesFade = (component) =>
      component.classList.contains('wc-rich-slideshow') &&
      component.dataset.transitionStyle !== 'slide';

    const getDragTargetIndex = (component, deltaX) => {
      const slideCount = component.sliderItemsToShow?.length || 0;

      if (slideCount < 2) return 0;

      const currentIndex = Number.isFinite(component._richSlideIndex)
        ? component._richSlideIndex
        : Math.max(0, (component.currentPage || 1) - 1);
      const draggedLeft = deltaX < 0;
      const direction = document.dir === 'rtl'
        ? draggedLeft
          ? -1
          : 1
        : draggedLeft
          ? 1
          : -1;
      let targetIndex = currentIndex + direction;

      if (component.enableSliderLooping) {
        targetIndex = (targetIndex + slideCount) % slideCount;
      } else {
        targetIndex = Math.max(0, Math.min(targetIndex, slideCount - 1));
      }

      return targetIndex;
    };

    const installFadeDrag = (component) => {
      if (component.wcFadeDragInstalled || !component.slider) return;

      component.wcFadeDragInstalled = true;

      const slider = component.slider;
      let mouseGesture = null;
      let touchGesture = null;
      let blockClicksUntil = 0;

      const setLinksEnabled = (enabled) => {
        slider.querySelectorAll('a').forEach((link) => {
          link.style.pointerEvents = enabled ? '' : 'none';
        });
      };

      const runDragTransition = (deltaX) => {
        if (component._isSlideTransitioning) return;

        const targetIndex = getDragTargetIndex(component, deltaX);
        component.goToSlideByIndex(targetIndex);
      };

      slider.addEventListener(
        'mousedown',
        (event) => {
          if (
            !usesFade(component) ||
            event.button !== 0 ||
            event.target.closest('product-model, model-viewer')
          ) {
            return;
          }

          event.stopImmediatePropagation();
          mouseGesture = {
            startX: event.pageX,
            startY: event.pageY,
            deltaX: 0,
            horizontal: false,
            moved: false,
          };
          slider.classList.add('is-dragging');
        },
        true
      );

      document.addEventListener(
        'mousemove',
        (event) => {
          if (!mouseGesture || !usesFade(component)) return;

          const deltaX = event.pageX - mouseGesture.startX;
          const deltaY = event.pageY - mouseGesture.startY;

          if (!mouseGesture.moved && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 6) {
            mouseGesture.moved = true;
            mouseGesture.horizontal = Math.abs(deltaX) >= Math.abs(deltaY);

            if (mouseGesture.horizontal) setLinksEnabled(false);
          }

          if (!mouseGesture.horizontal) return;

          mouseGesture.deltaX = deltaX;
          event.preventDefault();
          event.stopImmediatePropagation();
        },
        true
      );

      document.addEventListener(
        'mouseup',
        (event) => {
          if (!mouseGesture) return;

          const gesture = mouseGesture;
          mouseGesture = null;
          slider.classList.remove('is-dragging');
          setLinksEnabled(true);

          if (!usesFade(component) || !gesture.horizontal) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          blockClicksUntil = performance.now() + 500;

          const threshold = Math.max(45, Math.min(slider.clientWidth * 0.1, 100));
          if (Math.abs(gesture.deltaX) >= threshold) {
            runDragTransition(gesture.deltaX);
          }
        },
        true
      );

      slider.addEventListener(
        'touchstart',
        (event) => {
          if (!usesFade(component) || event.touches.length !== 1) return;

          const touch = event.touches[0];
          touchGesture = {
            startX: touch.clientX,
            startY: touch.clientY,
            deltaX: 0,
            horizontal: false,
            vertical: false,
            moved: false,
          };
        },
        { capture: true, passive: true }
      );

      slider.addEventListener(
        'touchmove',
        (event) => {
          if (!touchGesture || !usesFade(component) || event.touches.length !== 1) return;

          const touch = event.touches[0];
          const deltaX = touch.clientX - touchGesture.startX;
          const deltaY = touch.clientY - touchGesture.startY;

          if (!touchGesture.moved && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 8) {
            touchGesture.moved = true;
            touchGesture.horizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.1;
            touchGesture.vertical = !touchGesture.horizontal;

            if (touchGesture.horizontal) setLinksEnabled(false);
          }

          if (touchGesture.vertical || !touchGesture.horizontal) return;

          touchGesture.deltaX = deltaX;
          event.preventDefault();
          event.stopImmediatePropagation();
          slider.classList.add('is-dragging');
        },
        { capture: true, passive: false }
      );

      slider.addEventListener(
        'touchend',
        (event) => {
          if (!touchGesture) return;

          const gesture = touchGesture;
          touchGesture = null;
          slider.classList.remove('is-dragging');
          setLinksEnabled(true);

          if (!usesFade(component) || !gesture.horizontal) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          blockClicksUntil = performance.now() + 700;

          const threshold = Math.max(40, Math.min(slider.clientWidth * 0.1, 80));
          if (Math.abs(gesture.deltaX) >= threshold) {
            runDragTransition(gesture.deltaX);
          }
        },
        { capture: true, passive: false }
      );

      slider.addEventListener(
        'touchcancel',
        () => {
          touchGesture = null;
          slider.classList.remove('is-dragging');
          setLinksEnabled(true);
        },
        true
      );

      slider.addEventListener(
        'click',
        (event) => {
          if (performance.now() < blockClicksUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true
      );
    };

    prototype.wcCrossfadeInstalled = true;

    prototype.transitionRichSlideshow = function transitionRichSlideshow(index) {
      if (!usesFade(this)) {
        return originalTransition.call(this, index);
      }

      if (this._isSlideTransitioning) return;

      const firstSlide = this.sliderItemsToShow?.[0];
      const targetSlide = this.sliderItemsToShow?.[index];
      const activeSlide =
        this._activeSlide ||
        this.getActiveSlide?.() ||
        this.sliderItemsToShow?.[this._richSlideIndex];

      if (!firstSlide || !targetSlide || !activeSlide || targetSlide === activeSlide) {
        return;
      }

      const targetScrollLeft = targetSlide.offsetLeft - firstSlide.offsetLeft;

      const completeTransition = () => {
        this.slider.scrollTo({ left: targetScrollLeft });
        this.slider.scrollLeft = targetScrollLeft;
        this._richSlideIndex = index;
        this._forcedRichPage = index + 1;
        this.update();
        this._forcedRichPage = null;
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        completeTransition();
        return;
      }

      this._isSlideTransitioning = true;
      this.slider.classList.add('slider--no-snap', 'rich-slideshow--crossfading');

      const beginCrossfade = () => {
        const overlayOffset = activeSlide.offsetLeft - targetSlide.offsetLeft;

        targetSlide.classList.add('active', 'rich-slideshow__slide--incoming');
        targetSlide.style.transform = `translate3d(${overlayOffset}px, 0, 0)`;
        targetSlide.style.zIndex = '2';
        targetSlide.style.pointerEvents = 'none';
        targetSlide.style.willChange = 'opacity';

        const incomingAnimation = targetSlide.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          {
            duration: FADE_DURATION,
            easing: FADE_EASING,
            fill: 'forwards',
          }
        );

        const outgoingAnimation = activeSlide.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          {
            duration: FADE_DURATION,
            easing: FADE_EASING,
            fill: 'forwards',
          }
        );

        Promise.all([
          incomingAnimation.finished.catch(() => undefined),
          outgoingAnimation.finished.catch(() => undefined),
        ]).then(() => {
          this.slider.scrollTo({ left: targetScrollLeft });
          this.slider.scrollLeft = targetScrollLeft;

          activeSlide.classList.remove('active');
          targetSlide.classList.remove('rich-slideshow__slide--incoming');

          targetSlide.style.removeProperty('transform');
          targetSlide.style.removeProperty('z-index');
          targetSlide.style.removeProperty('pointer-events');
          targetSlide.style.removeProperty('will-change');

          incomingAnimation.cancel();
          outgoingAnimation.cancel();

          this._richSlideIndex = index;
          this._forcedRichPage = index + 1;
          this.update();
          this._forcedRichPage = null;

          this.slider.classList.remove('slider--no-snap', 'rich-slideshow--crossfading');

          requestAnimationFrame(() => {
            this._isSlideTransitioning = false;
          });
        });
      };

      const incomingImage = targetSlide.querySelector('img');

      if (incomingImage && !incomingImage.complete && incomingImage.decode) {
        Promise.race([
          incomingImage.decode().catch(() => undefined),
          new Promise((resolve) => window.setTimeout(resolve, 800)),
        ]).then(beginCrossfade);
      } else {
        beginCrossfade();
      }
    };

    document
      .querySelectorAll('slideshow-component.wc-rich-slideshow')
      .forEach(installFadeDrag);
  });
})();